{
  "version": 1,
  "asset_id": "dcc99f5d-6a34-4225-b022-579b717e7d4e",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/dcc99f5d-6a34-4225-b022-579b717e7d4e/libera5.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/dcc99f5d-6a34-4225-b022-579b717e7d4e/libera5.webp",
  "original_filename": "libera5.webp",
  "size": 33668,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:56Z"
}
